/*
 * Buckle colour selector — adds the chosen *paid* buckle to the cart as a
 * separate line item after the watch is added.
 *
 * Approach: subscribe to the cartUpdate event that product-form.js publishes
 * after a successful add. When the watch was added and a non-free buckle is
 * selected, fire a follow-up /cart/add for the buckle, requesting the cart
 * drawer/notification sections so it re-renders with both lines. No override
 * of core theme JS.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  var adding = false;

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getWatchQuantity() {
    var input = document.querySelector('product-info [name="quantity"]') || document.querySelector('[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  // Find a paid, selected buckle on the page. Returns {id, title} or null.
  function getSelectedPaidBuckle() {
    var selectors = document.querySelectorAll('[data-buckle-selector]');
    for (var i = 0; i < selectors.length; i++) {
      var checked = selectors[i].querySelector('input[type="radio"]:checked');
      if (!checked) continue;
      if (checked.dataset.isFree === 'true') continue; // free (Silver) — no line item
      if (!checked.value) continue;
      return { id: checked.value, title: checked.dataset.buckleTitle || '' };
    }
    return null;
  }

  function addBuckle(buckle) {
    if (adding) return;
    adding = true;

    var productTitleEl = document.querySelector('.product__title h1, .product__title, h1');
    var productTitle = productTitleEl ? productTitleEl.textContent.trim() : '';

    var item = { id: buckle.id, quantity: getWatchQuantity() };
    if (productTitle) {
      item.properties = { _buckle_for: productTitle };
    }

    var body = { items: [item] };

    var cart = getCartElement();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error('Buckle add failed:', response.description || response.message);
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }
      })
      .catch(function (e) {
        console.error('Buckle add error:', e);
      })
      .finally(function () {
        adding = false;
      });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event || event.source !== 'product-form') return;
    var buckle = getSelectedPaidBuckle();
    if (!buckle) return;
    addBuckle(buckle);
  });
})();